import { render } from "./IconSearch.vue?vue&type=template&id=092c3bf7"
import script from "./IconSearch.vue?vue&type=script&lang=js"
export * from "./IconSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__